import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormSubmitButton from "../FormParts/FormSubmitButton";
import Form from "react-bootstrap/Form";
import FormButton from "../FormParts/FormButton";
import UserProfile from "../Context/UserProfile";
import "./DetailPO.css";
import OtherData from "../Context/OtherData";
import ChatComponent from "../CommonPages/ChatComponent";

const AIGenerateContract = ({ setUserName }) => {
	const navigate = useNavigate();
	const poForm = useRef(null);
	useEffect(() => {
		// if (UserProfile.getLoginStatus() !== "1") {
		// 	navigate("/");
		// }
		setUserName(UserProfile.getName());
	}, []);
	const handleSubmit = (e) => {
		e.preventDefault();
	};
	//Home Maintenance Contract – Hiring plumbers, electricians, painters


	return (
        <>
			<div className="main-content" style={UserProfile.getLoginStatus()!=="1"? {marginLeft:"0px"}:{}}>
				{UserProfile.getLoginStatus()!=="1" && <><header>
						<div className="header-container">
							<div className="logo">
								<a style={{ textDecoration: "none" }} href="/">
									<span style={{ color: 'white' }}>Contr
										<span style={{ color: "#ff8400" }}>e</span>
										ct</span>
								</a>

							</div>
							<nav><a href="/Signup" className="btn btn-success">Sign In</a>
							</nav>
						</div>
					</header>
					<div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
						<h1>Terms and Conditions</h1>
						<span className="effective-date">Last Updated: 3 December 2025</span>
					</div></>}
				<div className="row">
					<div className="col-2">
						<button className="btn btn-primary" onClick={(e)=>{
					OtherData.resetData();
					navigate("/DraftContract");}}>Create from scratch</button>
					</div>
				</div>
				
				<ChatComponent/>
            </div>
		</>
	);
};
export default AIGenerateContract;
